import type { LifecycleAutoSource } from '@/config/shared/auto-source';
import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

import { BaseAutoTracker } from '../../auto/BaseAutoTracker';
import { buildAutoSourceOrigin } from '../../auto/build-auto-source-origin';
import type {
  ConversionEventOrigin,
  ConversionEventType,
} from '../../contracts';
import type { TrackerFactory } from '../../tracks/TrackerFactory';

export type LifecycleAutoDetectorOptions = {
  readonly eventType: ConversionEventType;
  readonly source: LifecycleAutoSource;
  readonly origin?: ConversionEventOrigin;
};

/**
 * Dispara evento no lifecycle do Pixel (init/ready), sem listeners DOM.
 */
export class LifecycleAutoDetector extends BaseAutoTracker {
  private readonly factory: TrackerFactory;

  private readonly options: LifecycleAutoDetectorOptions;

  private readonly fireOnce: boolean;

  private readonly origin: ConversionEventOrigin;

  private hasFired = false;

  constructor(
    context: PixelRuntimeContext,
    factory: TrackerFactory,
    options: LifecycleAutoDetectorOptions
  ) {
    super(context);
    this.factory = factory;
    this.options = options;
    this.fireOnce = options.source.fireOnce !== false;
    this.origin =
      options.origin ??
      buildAutoSourceOrigin(
        'lifecycle',
        options.eventType,
        options.source.name
      );
  }

  get name(): string {
    return `Lifecycle(${this.options.eventType}:${this.options.source.name})`;
  }

  protected onInit(): void {
    this.hasFired = false;
    // init e ready: no momento do init do detector o Pixel já está pronto.
    this.fire();
  }

  protected onDestroy(): void {
    this.hasFired = false;
  }

  private fire(): void {
    if (this.fireOnce && this.hasFired) return;

    this.factory.trackAuto(
      this.options.eventType,
      {},
      {
        origin: this.origin,
      }
    );

    if (this.fireOnce) {
      this.hasFired = true;
    }
  }
}
